import { render } from "./row.vue?vue&type=template&id=1b40a0b4&scoped=true"
import script from "./row.vue?vue&type=script&lang=js"
export * from "./row.vue?vue&type=script&lang=js"

import "./row.vue?vue&type=style&index=0&id=1b40a0b4&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b40a0b4"]])

export default __exports__